import styled from 'styled-components';
import { UI_MAX_WIDTH } from '../../../utils/constants';

export const DashboardContentContainer = styled.div<{ maxWidth?: number, minWidth?: number, paddingBottom?: number }>`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: ${(props) => (props.maxWidth || UI_MAX_WIDTH)}px;
  min-width: ${(props) => (props.minWidth || 1200)}px;
  box-sizing: border-box;
  padding-bottom: ${(props) => props.paddingBottom ?? 32}px;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.Tablet}) {
    min-width: 0px;
    width: 100%;
  }
`;
